import uuidv4 from 'uuid/v4';
import {
  CLEAR_SEARCH,
  UPDATE_SEARCH_FIELD,
  UPDATE_SEARCH_SUGGESTIONS,
  SET_NEXT_SEARCH_SUGGESTION,
  SET_PREVIOUS_SEARCH_SUGGESTION,
  SET_SEARCH_SUGGESTION,
  RECEIVE_SEARCH_SUGGESTIONS_ERROR,
} from '../actions/search';
import { REGISTER_SEARCH_TERM } from 'apps/catalogue/actions/catalogue';

export const initialState = {
  value: '',
  searchSuggestions: {},
};

function getSelectedSuggestionIndex(suggestions, selectedSearchSuggestion) {
  return suggestions.indexOf(selectedSearchSuggestion);
}

function getNextSearchSuggestion(suggestions, selectedSearchSuggestion) {
  const selectedSuggestionIndex = getSelectedSuggestionIndex(suggestions, selectedSearchSuggestion);
  const newSuggestionIndex = selectedSuggestionIndex + 1;
  if (newSuggestionIndex >= suggestions.length) { // from last suggestion go to first
    return suggestions[0];
  }
  return suggestions[newSuggestionIndex];
}

function getPreviousSearchSuggestion(suggestions, selectedSearchSuggestion) {
  const selectedSuggestionIndex = getSelectedSuggestionIndex(suggestions, selectedSearchSuggestion);
  const newSuggestionIndex = selectedSuggestionIndex - 1;
  if (newSuggestionIndex < 0) { // from first suggestion go back to last
    return suggestions[suggestions.length - 1];
  }
  return suggestions[newSuggestionIndex];
}

const ACTIONS = {
  [CLEAR_SEARCH]: ({ state }) => ({
    ...state,
    value: '',
    searchSuggestions: {},
    selectedSearchSuggestion: '',
  }),
  [UPDATE_SEARCH_FIELD]: ({ state, action }) => ({
    ...state,
    value: action.value,
  }),
  [UPDATE_SEARCH_SUGGESTIONS]: ({ state, action }) => ({
    ...state,
    searchSuggestions: action.searchSuggestions,
    selectedSearchSuggestion: '',
  }),
  [SET_SEARCH_SUGGESTION]: ({ state, action }) => ({
    ...state,
    selectedSearchSuggestion: action.suggestion,
  }),
  [SET_NEXT_SEARCH_SUGGESTION]: ({ state }) => {
    const nextSearchSuggestion = getNextSearchSuggestion(state.searchSuggestions.suggestions,
      state.selectedSearchSuggestion);
    return {
      ...state,
      selectedSearchSuggestion: nextSearchSuggestion,
      value: nextSearchSuggestion.toLowerCase(),
    };
  },
  [SET_PREVIOUS_SEARCH_SUGGESTION]: ({ state }) => {
    const previousSearchSuggestion = getPreviousSearchSuggestion(state.searchSuggestions.suggestions,
      state.selectedSearchSuggestion);
    return {
      ...state,
      selectedSearchSuggestion: previousSearchSuggestion,
      value: previousSearchSuggestion.toLowerCase(),
    };
  },
  [RECEIVE_SEARCH_SUGGESTIONS_ERROR]: ({ state, action }) => ({
    ...state,
    error: action.error,
  }),
  [REGISTER_SEARCH_TERM]: ({ state, action }) => {
    const { searchTerm } = action;
    let lastSearch = state && state.lastSearch;
    if (!lastSearch || (lastSearch && lastSearch.term !== searchTerm)) {
      lastSearch = {
        term: searchTerm,
        searchId: uuidv4(),
      };
    }
    return { ...state, lastSearch };
  },
};

export default function search(state = initialState, action) {
  return ACTIONS[action.type] ? ACTIONS[action.type]({ state, action }) : state;
}
